import Basemap from "@arcgis/core/Basemap";
import ArcGISMap from "@arcgis/core/Map";
import WebMap from "@arcgis/core/WebMap";
import MapView from "@arcgis/core/views/MapView";
import { getViewMinZoom, setAsyncError } from "../utils/helper";
// setDefaultOptions({ css: true });

export const createMap = async (config, setError) => {
  try {
    if (!config.webmap) {
      const basemap = config.basemapId
        ? new Basemap({ portalItem: { id: config.basemapId } })
        : Basemap.fromId(config.basemap);

      return new ArcGISMap({ basemap: basemap });
    } else {
      return new WebMap({
        portalItem: {
          id: config.webmap,
        },
      });
    }
  } catch (err) {
    setAsyncError(err, setError);
  }
};

export const createView = async ({
  container,
  map,
  config,
  countryGeometry,
  setError,
}) => {
  try {
    let countryCenter =
      countryGeometry && countryGeometry.centroid
        ? countryGeometry.centroid
        : null;
    let view;
    if (!config.webmap) {
      view = new MapView({
        map,
        container,
        zoom: config.zoom,
        center: config.center
          ? config.center
          : countryCenter
          ? countryCenter
          : [0, 0],
        extent:
          countryGeometry && countryGeometry.extent
            ? countryGeometry.extent
            : null,
        popup: {
          defaultPopupTemplateEnabled: false, //to remove default popup which appears on click (e.g. homescreen)
        },
      });
    } else {
      view = new MapView({
        map,
        container,
        extent:
          countryGeometry && countryGeometry.extent
            ? countryGeometry.extent
            : null,
        popup: { defaultPopupTemplateEnabled: false }, //to remove default popup which appears on click (e.g. homescreen)
      });

      if (countryCenter !== undefined) {
        view.center = countryCenter;
      }

      if (config.zoom !== null) {
        view.zoom = config.zoom;
      }

      if (config.center !== null) {
        view.center = config.center;
      }
    }

    if (config.minZoom) {
      view.constraints.minZoom = getViewMinZoom(view, config.minZoom);
    }

    if (config.maxZoom) view.constraints.maxZoom = config.maxZoom;

    view.ui.components = [];
    view.constraints.snapToZoom = false;

    // view.constraints.geometry = {
    //   type: "extent",
    //   xmin: -180,
    //   ymin: -75, // Avoid -90 to prevent gray at the poles
    //   xmax: 180,
    //   ymax: 75, // Avoid 90 to prevent gray at the poles
    //   spatialReference: { wkid: 4326 },
    // };

    view.popup.dockOptions = {
      // Disable the dock button so users cannot undock the popup
      buttonEnabled: false,
      breakpoint: false,
    };
    view.popup.visibleElements = {
      actionBar: false,
      closeButton: false,
      collapseButton: false,
      featureNavigation: false,
      heading: true,
    };
    // view.popup.dockEnabled = false;
    view.popupEnabledCustom = true;

    return view;
  } catch (err) {
    setAsyncError(err, setError);
  }
};
